<template>
  <div class="nettdoc-weakness-or-exhaustion">
    <SectionHeader
      text="I'm feeling weak or exhausted"
      img="exhausting"
      alt="exhausted man"
      :collapsable="true"
      v-on:collapse="() => collapsed = !collapsed"
      :complete="store.weaknessOrExhaustionDetails.submitted"
    />
    <template v-if="collapsed">
      <SectionHeader text="tumorOrCancer" :dark="true" />
      <TripleChoice
        :model="store.weaknessOrExhaustionDetails.tumorOrCancer"
        v-on:action="value => store.addWeaknessOrExhaustionDetails('tumorOrCancer', value)"
      />

      <SectionHeader text="weightLoss" :required="false" :dark="true" />
      <YesNo
        :model="store.weaknessOrExhaustionDetails.weightLoss"
        v-on:action="value => store.addWeaknessOrExhaustionDetails('weightLoss', value)"
      />

      <SectionHeader text="sweatAtNight" :required="false" :dark="true" />
      <YesNo
        :model="store.weaknessOrExhaustionDetails.sweatAtNight"
        v-on:action="value => store.addWeaknessOrExhaustionDetails('sweatAtNight', value)"
      />

      <SectionHeader text="heavySweatAtNight" :required="false" :dark="true" />
      <YesNo
        :model="store.weaknessOrExhaustionDetails.heavySweatAtNight"
        v-on:action="value => store.addWeaknessOrExhaustionDetails('heavySweatAtNight', value)"
      />

      <SectionHeader text="bloodyExcrements" :dark="true" />
      <TripleChoice
        :model="store.weaknessOrExhaustionDetails.bloodyExcrements"
        v-on:action="value => store.addWeaknessOrExhaustionDetails('bloodyExcrements', value)"
      />

      <SectionHeader text="bloodyCough" :required="false" :dark="true" />
      <YesNo
        :model="store.weaknessOrExhaustionDetails.bloodyCough"
        v-on:action="value => store.addWeaknessOrExhaustionDetails('bloodyCough', value)"
      />

      <SectionHeader text="heartDisease" :dark="true" />
      <TripleChoice
        :model="store.weaknessOrExhaustionDetails.heartDisease"
        v-on:action="value => store.addWeaknessOrExhaustionDetails('heartDisease', value)"
      />

      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.weaknessOrExhaustionDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader"
import YesNo from '../YesNo'
import TripleChoice from '../TripleChoice'
import Button from '../Button'
export default observer({
  name: "WeaknessOrExhaustion",
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, TripleChoice
  },
  methods: {
    submit: function() {
      this.store.weaknessOrExhaustionDetails.submitted = true
      localStorage.setItem(
        "weaknessOrExhaustionDetails",
        JSON.stringify(this.store.weaknessOrExhaustionDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>
</style>